import React, { useEffect, useState } from 'react'
import { Button, Card, Row, Table } from "antd";
import { getOwnAppointments, getAppointmentWithPage } from "../../services/serviceAppointment";
import AppointmentCreate from "./AppointmentCreate";
import AppointmentActions from "./AppointmentActions";
import AppointmentTags from "./AppointmentTags";
import userDateFormatter from "../../services/formatters/userDateFormatter";
import AppointmentFilter from "./AppointmentFilter";
import Filter from "../filterWrapper/Filter";
import { SearchOutlined } from "@ant-design/icons";
import { useLocation } from "@reach/router";

const Appointment = ({ navigate }) => {
    const location = useLocation();
    const [newModal, setNewModal] = useState(false);
    const [sortedList, setSortedList] = useState([]);
    const [openFilter, setOpenFilter] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [filters, setFilters] = useState({
        customerName: '',
        planningDate: '',
        createdBy: ''
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getAppointments(page, pageSize);
    }, [location.search]);

    const getAppointments = (page, pageSize, requestObj = filters) => {
        const mockFilters = { ...requestObj };
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;

        getAppointmentWithPage(mockFilters)
            .then(({ data }) => {
                handlers.sortData(data.content)
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    };

    const handlers = {
        updater() {
            navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            const sorted = list.map(appointment => ({
                key: appointment.id,
                id: appointment.id,
                customer: appointment.cn || appointment.customer.name,
                employee: appointment.e || appointment.employee.name,
                resultText: appointment.rt || appointment.resultText,
                appointmentCustomer: appointment.cn || appointment.customer.name,
                appointmentRelevant: appointment.rp || `${appointment.relevantPerson.name} - ${appointment.relevantPerson.surname}`,
                status: appointment.s || appointment.status,
                appointmentCreator: appointment.e || `${appointment.employee.name} - ${appointment.employee.surname}`,
                appointmentDate: appointment.pd || appointment.planningDate,
                appointmentBrand: appointment.bn || appointment?.brand?.code
            }))
            setSortedList(sorted)
        }
    }
    const toggleFilterDisplay = () => setOpenFilter(!openFilter);

    function handleFilter({ customerName, planningDate, createdBy }) {
        arguments[0].planningDate = arguments[0].planningDate.hasOwnProperty('_d') ? arguments[0].planningDate._d : null
        const requestObj = {}
        Object.keys(arguments[0]).map(key => requestObj[key] = arguments[0][key])
        setFilters(requestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
        return new Promise((resolve => resolve(200)))
    }

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const resetFilter = () => {
        const baseFilters = {
            customerName: '',
            planningDate: '',
            createdBy: ''
        }
        setFilters(baseFilters);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
    }

    const columns = [
        {
            title: 'Oluşturan',
            dataIndex: 'appointmentCreator',
            key: 'appointmentCreator',
        },
        {
            title: 'Randevu Tarihi',
            dataIndex: 'appointmentDate',
            key: 'appointmentDate',
            render: (text, record) => userDateFormatter(record.appointmentDate)
        },
        {
            title: 'Marka',
            dataIndex: 'appointmentBrand',
            key: 'appointmentBrand'
        },
        {
            title: 'İlgili',
            dataIndex: 'appointmentRelevant',
            key: 'appointmentRelevant'
        },
        {
            title: 'Müşteri',
            dataIndex: 'appointmentCustomer',
            key: 'appointmentCustomer'
        },
        {
            title: 'Durum',
            key: 'appointmentStatus',
            render: (text, record) => <AppointmentTags status={record.status} report={record.resultText} />
        },
        {
            title: 'İşlemler',
            key: 'appointmentActions',
            render: (text, record) => <AppointmentActions record={record} updater={handlers.updater} />
        }

    ];

    const getOnlyMe = () => {
        getOwnAppointments()
            .then(({ data }) => {
                return handlers.sortData(data)
            })
    };

    return (
        <React.Fragment>
            <Card
                title={'Randevu Listesi'}
                extra={
                    <Button
                        type={'primary'}
                        onClick={() => setNewModal(!newModal)}
                    >
                        Yeni Ekle
                    </Button>
                }
            >
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
                    <div className={'filter-row-container'}>
                        <Button
                            type={'primary'}
                            onClick={getOnlyMe}
                        >Sadece Ben</Button>
                    </div>
                </Row>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <AppointmentCreate show={newModal} modalCloser={handlers.modalCloser}
                updater={handlers.updater} /> : null}
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Randevu'}
                    handler={handleFilter}
                    resetHandler={resetFilter}
                >
                    <AppointmentFilter />
                </Filter>
            }
        </React.Fragment>
    );
}
export default Appointment